import { cn } from '@/shared/utils/shadcn';
import { useLocale, useTranslations } from 'next-intl';
import React from 'react';

const ToolsAssessment = ({ className }: { className?: string }) => {
  const t = useTranslations();
  const currentLocale = useLocale();

  return (
    <div
      style={{
        background: `url(/images/common/assessment.png)`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
      className={cn(
        'fixed bottom-24 right-12 z-[51] flex h-[141px] w-[150px] cursor-pointer flex-col items-center justify-center max-md:right-[30px] max-md:h-[93px] max-md:w-[100px]',
        className,
      )}
      onClick={() => {
        window.open(process.env.NEXT_PUBLIC_WEBSITE + '/快速评估表/', '_blank');
      }}
    >
      <div
        className={`${currentLocale === 'en' ? 'text-[12px] leading-none' : 'text-[14px] leading-[14px]'} text-center font-medium text-[#212136] max-md:text-[10px] max-md:leading-[10px]`}
      >
        <div className={`mb-2 max-md:mb-[3px] ${currentLocale === 'en' ? 'px-3' : ''}`}>
          {t('Tools.toolsAssessment1')}？
        </div>
        <div className={`${currentLocale === 'en' ? 'px-4' : ''}`}>{t('Tools.toolsAssessment2')}</div>
      </div>
      <div
        style={{ background: 'linear-gradient(0deg, #212136 0%, #383881 98%)' }}
        className={`mt-3 flex h-[28px] w-[77px] flex-row items-center justify-center rounded-[18px] text-center text-[12px] text-white max-md:mt-[10px] max-md:h-[20px] max-md:w-[56px] max-md:text-[10px] ${currentLocale === 'en' ? 'h-8 w-[90px] text-[10px] leading-none' : ''}`}
      >
        {t('Tools.toolsAssessment3')}
      </div>
    </div>
  );
};

export default ToolsAssessment;
